import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import { TopProductsCompareRequest, TopProductsResponse, useTopProduct } from '../../../../api/indicators';
import { DashboardFiltersContext } from '../filters/DashboardFiltersContext';
import { DashboardContext } from '../../DashboardContext';
import { UserContext } from '../../../../context/UserContext';
import { dateRange } from '../../../../helpers/dateUtils';
import PieBarChart, { PieBarChartData } from '../charts/PieBarChart';

const NetMarginByProduct = () => {
    const { t } = useTranslation();
    const { locale } = useContext(UserContext);
    const { filters, dateRangeConfig } = useContext(DashboardFiltersContext);
    const { refreshDate } = useContext(DashboardContext);

    const DEFAULT_LIMIT_PRODUCTS = 10;


    const [params, setParams] = useState<TopProductsCompareRequest>({
        fields: 'netMargin',
        startDateTime: filters.periodFrom ? filters.periodFrom : dateRange("today", undefined, undefined, undefined, dateRangeConfig).startDate,
        endDateTime: filters.periodTo ? filters.periodTo : dateRange("today", undefined, undefined, undefined, dateRangeConfig).endDate,
        locations: filters?.locations?.join(','),
        locationArea: filters?.locationArea?.id,
        limit: DEFAULT_LIMIT_PRODUCTS

    });

    const {
        data: topProductsResponse,
        isLoading,
        isError,
        refetch: fetchTopProducts
    } = useTopProduct<TopProductsResponse>(params, 'top-products-net-margin');

    useEffect(() => {
            setParams(p => ({
                ...p,
                startDateTime: filters.periodFrom || dateRange("today", undefined, undefined, undefined, dateRangeConfig).startDate,
                endDateTime:filters.periodTo || dateRange("today", undefined, undefined, undefined, dateRangeConfig).endDate,
                locations: filters?.locations?.join(','),
                locationArea: filters?.locationArea?.id
            }));
        }, [filters, dateRangeConfig]);
    
        useEffect(() => {fetchTopProducts();}, [params, fetchTopProducts]);
    
        useEffect(() => {
            if (refreshDate != null) {
                fetchTopProducts();
            }
        }, [refreshDate, fetchTopProducts]);

    return (
        <Box>
            <PieBarChart
                title={t("screens.dashboarding.charts.netMarginByProduct")}
                description={t("screens.dashboarding.charts.excludingTax")}
                data={topProductsResponse?.topProducts?.netMargin?.map(v => ({
                    value: v.netMargin,
                    label: v.productName,
                })) as PieBarChartData[]}
                currency={topProductsResponse?.currency}
                locale={locale}
                isLoading={isLoading}
                error={isError}
                reportName={t('screens.dashboarding.charts.salesByProduct')}
                reportLink={`${process.env.REACT_APP_LINK_BACK_OFFICE}Pages/Reporting/DailySales.aspx`}
            />
        </Box>
    )
}

export default NetMarginByProduct;
